var _defs, _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoPriceMarkerWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "35px",
    height: "35px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    id: "svg24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs28"
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata16"
  }, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500.3,193.3c-95.8,0-173.8,77.5-173.8,172.8c0,95.4,78,172.8,173.8,172.8c95.8,0,173.7-77.5,173.7-172.8C674,270.8,596.1,193.3,500.3,193.3L500.3,193.3z M500.3,481.1c-63.7,0-115.6-51.5-115.6-115c0-63.3,51.9-115,115.6-115c63.7,0,115.5,51.6,115.5,115C615.9,429.5,564,481.1,500.3,481.1L500.3,481.1z",
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.1,990c-15.3,0-32.2-6.8-51.6-21c-15.2-11.1-32.2-26.8-50.5-46.7c-36-39.2-75.3-93-110.8-151.5c-39.4-65.1-72.7-133.5-96.3-198c-27.8-76.2-42-145.8-42-206.6c0-95.1,36.5-184.6,102.8-251.8C318.1,47,406.3,10,500,10c93.7,0,181.9,37,248.2,104.3C814.5,181.6,851,271,851,366.1c0,60.8-14.2,130.4-42.2,206.7c-23.4,64.4-56.8,132.8-96.4,197.9c-35.4,58.3-74.8,112.2-110.8,151.4c-18.2,19.8-35.1,35.6-50.3,46.7C532,983.2,515.3,990,500.1,990L500.1,990z M500.1,69.2c-78.2,0-151.7,30.9-206.9,87c-55.3,56.1-85.7,130.7-85.7,210c0,100.1,46.1,234.4,126.4,368.7c32.8,54.8,69.2,105.3,102.6,142.6c36.6,40.7,57.7,52.2,63.6,53.5c5.8-1.4,27-13.1,63.6-54.1c33.4-37.4,69.9-88.1,102.6-142.7c80.6-134.2,126.7-268.3,126.7-368c0-79.3-30.4-153.9-85.7-210C651.8,100,578.3,69.2,500.1,69.2L500.1,69.2z",
    id: "path20"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#000000"
    },
    id: "path188",
    cx: 500.60315,
    cy: 360.67551,
    rx: 124.24608,
    ry: 131.48372
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      strokeWidth: 0.852964
    },
    d: "M 495.09957,928.44775 C 483.24018,922.44494 462.34429,904.63256 444.25578,885.10662 375.66172,811.06165 302.13602,691.65758 257.96469,582.5741 231.65052,517.58985 215.75462,458.22131 209.66218,402.17231 c -1.48847,-13.69353 -1.47676,-57.67686 0.0185,-69.51653 5.31735,-42.1034 16.82426,-78.01469 35.94176,-112.16863 C 287.62186,145.454 360.16518,91.961044 442.25632,75.490662 c 22.37464,-4.489144 29.03622,-5.077917 57.58032,-5.089146 28.8231,-0.01134 36.24754,0.643775 58.60597,5.171245 30.23678,6.122792 61.76488,18.312233 88.73734,34.307759 75.97846,45.05763 127.99548,121.97397 141.71751,209.55433 9.44289,60.26886 0.01,130.65111 -28.8977,215.61514 -27.85387,81.86679 -74.57053,173.48593 -129.77383,254.50809 -41.75225,61.27998 -84.26502,110.28234 -114.47057,131.94456 -6.56358,4.70711 -14.13614,9.08059 -15.72289,9.08059 -0.39262,0 -2.61242,-0.96095 -4.9329,-2.13548 z m 27.51016,-390.67911 c 39.87074,-5.16629 76.85964,-23.92078 104.12982,-52.79695 64.82044,-68.63785 63.22987,-174.93021 -3.61309,-241.4506 -79.35688,-78.9739 -212.24538,-63.15799 -271.44281,32.30614 -22.67522,36.56698 -30.66605,81.88261 -22.00047,124.76377 6.89359,34.1126 24.56769,66.05752 49.86855,90.13457 26.94187,25.63868 60.9569,42.06411 97.25489,46.96315 12.15457,1.64046 33.4726,1.67767 45.80311,0.0799 z",
    id: "path398"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPriceMarkerWhite);
export default __webpack_public_path__ + "static/media/no_price_marker_white.85580c54177b241127db37b5624a7726.svg";
export { ForwardRef as ReactComponent };